import React, { useState } from "react";
import { PrivatePhoto, PhotoPreview } from "@/pages/tech/VisitPhotos";

export const FindingEvidence = ({ visit, finding, index }) => {
  const [preview, setPreview] = useState(null);
  const photos = visit.photos.filter((p) => finding.photo_ids.includes(p.id));
  if (!photos.length) return null;
  return <div className="mt-4" data-testid={`office-finding-evidence-${index}`}><div className="grid grid-cols-2 sm:grid-cols-4 gap-3">{photos.map((photo) => <div className="field-photo" key={photo.id}><PrivatePhoto serviceId={visit.id} photo={photo} onOpen={setPreview} testId={`office-finding-${index}-photo-${photo.id}`} /></div>)}</div><PhotoPreview preview={preview} onClose={() => setPreview(null)} /></div>;
};